import s from './RestaurantQuickFilter.module.sass'

import React, { FC, useMemo } from 'react'

import { useAppSelector } from '@app/model/store'

import { RestaurantQuickFilterSkeleton } from '@widgets/Restaurant/RestaurantQuickFilter/index'
import { FilterItem } from '@widgets/Restaurant/RestaurantQuickFilter/ui/FilterItem'

import { Carousel } from '@shared/ui/Layout/Carousel'
import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'

import IconArrow from '@icons/icon-arrow-quick-filter.svg'

interface Props {
  className?: string
}

const RestaurantQuickFilter: FC<Props> = ({ className = '' }) => {
  const { isMobile } = useClientResponsive()

  const quickFilters = useAppSelector((store) => store.pages.app_home.sections.quickFilters)

  const currentCityId = useAppSelector((store) => store.global.currentCity.id)
  const cityRead = useAppSelector((store) => store.global.currentCity.id)

  const quickFiltersListMemo = useMemo(() => {
    return quickFilters.list?.map((filter) => <FilterItem key={`${currentCityId}-${filter.slug}`} data={filter} />)
  }, [quickFilters])

  if (quickFilters.loading || !cityRead) {
    return <RestaurantQuickFilterSkeleton className={className} />
  }

  return (
    <ErrorBoundary>
      {quickFilters.list?.length > 0 && (
        <div className={`${s.wrapper} ${className}`}>
          <Carousel>
            <div className={s.inner}>
              <div className={s.sliderControls}>
                <Carousel.Arrow direction={'prev'} className={s.sliderArrowPrev}>
                  <div className={s['arrowButton']}>
                    <IconArrow />
                  </div>
                </Carousel.Arrow>

                <Carousel.Arrow direction={'next'} className={s.sliderArrowNext}>
                  <div className={s['arrowButton']}>
                    <IconArrow />
                  </div>
                </Carousel.Arrow>
              </div>

              <Carousel.Slider shadow={true} slideMoveCount={3} className={s.slider}>
                {quickFiltersListMemo}
              </Carousel.Slider>
            </div>
          </Carousel>
        </div>
      )}
    </ErrorBoundary>
  )
}

export default RestaurantQuickFilter
